.uni-breadcrumbs {
  display: flex;
  align-items: center;
}

.uni-breadcrumbs-divider {
  padding: 0 5px;
}

.uni-breadcrumbs-home {
  cursor: pointer;
}

.uni-breadcrumbs-link {
  display: flex;
  cursor: pointer;
  text-decoration: underline;
}
